import { PageSectionsContentSectionContentBlocksTestimonialCardsTestimonial } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { tinaField } from 'tinacms/dist/react';
import { layout } from '../styles/layout';
import '../styles/tokens.stylex';
import { size, spacing } from '../styles/tokens.stylex';
import { RichText } from './RichText';
import { FiveStars } from './svg/images/fiveStars';
interface ReviewsListProps {
  data: PageSectionsContentSectionContentBlocksTestimonialCardsTestimonial[];
}
interface Review {
  data: PageSectionsContentSectionContentBlocksTestimonialCardsTestimonial;
}
export function ReviewsList({
  data,
  ...props
}: ReviewsListProps) {
  return data ? <ul className="xrvj5dj x1717udv x1mhrlx8 x131280q x107k3e6 x1ghz6dp" {...props}>
      {data.map((review, i) => <Review data={review} key={i + review.name.replace(/\s/, '')} />)}
    </ul> : null;
}
export function Review({
  data
}: Review) {
  return <li {...stylex.props([layout.contentCard, styles.review])}>
      <figure className="x78zum5 xdt5ytf x1qughib x3ybb33">
        <blockquote className="x98rzlu x1fzhlzt" data-tina-field={tinaField(data, 'description')}>
          <RichText>{data.description}</RichText>
        </blockquote>
        <span>
          <figcaption>
            <cite className="x117nqv4 x1j61x8r" data-tina-field={tinaField(data, 'name')}>
              {data.name}
            </cite>
          </figcaption>
          <FiveStars styles={styles.stars} />
        </span>
      </figure>
    </li>;
}
const styles = {
  review: {
    kB88ic: "xe8uvvx",
    k1xSpc: "x78zum5",
    kGNEyG: "x1qjc9v5",
    $$css: true
  },
  stars: {
    kZKoxP: "xqwie1i",
    $$css: true
  }
};